// @ts-nocheck
export const localeCodes =  [
  "en",
  "pt"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_661b6c44",
      load: () => import("#nuxt-i18n/661b6c44" /* webpackChunkName: "locale_en_46json_661b6c44" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_5b46922f",
      load: () => import("#nuxt-i18n/5b46922f" /* webpackChunkName: "locale_pt_46json_5b46922f" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/949ed66c" /* webpackChunkName: "config_i18n_46config_46ts_949ed66c" */)
]
export const normalizedLocales = [
  {
    code: "en",
    dir: "ltr",
    language: undefined
  },
  {
    code: "pt",
    dir: "ltr",
    language: undefined
  }
]
/** client **/

/** client-end **/